module.exports = __webpack_public_path__ + "img/proList2_30_1.4463a69e.jpg";